import { createElement, type CSSProperties, type ReactElement } from 'react';
import { sanitizeDisplayHtml } from './displaySanitize.ts';

export type DisplayTextElementProps = {
  text?: string | null;
  className?: string;
  style?: CSSProperties;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  dataName?: string;
  dataId?: string;
};

/**
 * Display-only text. Theme Stage/Fan pass through the same className + style
 * they used on ContentEditableDiv. FREEFORM adds box/%/cqh styles at the call site.
 */
export function DisplayTextElement({
  text,
  className,
  style,
  onClick,
  dataName,
  dataId,
}: DisplayTextElementProps): ReactElement {
  return createElement('div', {
    'data-name': dataName,
    'data-id': dataId,
    className,
    style,
    onClick,
    dangerouslySetInnerHTML: {
      __html: sanitizeDisplayHtml(text || ''),
    },
  });
}
